import { render, staticRenderFns } from "./InsuranceAuthorizationRecipeAddressSelector.vue?vue&type=template&id=4dee1f5e&"
import script from "./InsuranceAuthorizationRecipeAddressSelector.vue?vue&type=script&lang=js&"
export * from "./InsuranceAuthorizationRecipeAddressSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports